import { SVGProps } from 'react'

export const MercaiOpusIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="242"
      height="67"
      viewBox="0 0 242 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.2903 53.58L33.8518 19.1524L20.8972 13.2153H50.5644L28.6532 53.58H15.2903Z"
        fill="#183E44"
      />
      <path
        d="M42.1241 53.6159L60.7097 19.1524L57.36 13.2153H77.4103L55.499 53.58L42.1241 53.6159Z"
        fill="#183E44"
      />
      <path
        d="M104.268 13.2153L100.822 19.1524L82.2125 53.6517L68.9577 53.6398L87.5553 19.1524L84.2176 13.2153H104.268Z"
        fill="#183E44"
      />
      <path
        d="M68.5618 53.6517L71.9955 47.7266L90.6051 13.2153L103.872 13.2392L85.2624 47.7266L88.6121 53.6517H68.5618Z"
        fill="#183E44"
      />
      <g clipPath="url(#clip0_2464_6126)">
        <path
          d="M136.741 24.6344L129.117 38.9295L121.492 24.6344H118.066L117.894 42.2391H121.15V30.9102L127.522 42.2051L130.493 42.2542L137.084 30.9102V42.2391H140.339L140.168 24.6344H136.741Z"
          fill="#183E44"
        />
        <path
          d="M178.768 28.5025C178.026 25.9174 175.906 24.8608 173.405 24.6343C170.019 24.3287 166.213 24.8608 162.783 24.6343V42.2391H165.868V35.05L167.051 36.6614H172.036L175.55 42.2391H179.234L175.455 36.4086C178.67 35.3255 179.657 31.5781 178.772 28.4987L178.768 28.5025ZM174.271 33.6235C174.253 33.6348 174.221 33.6499 174.177 33.665C173.565 33.9217 172.906 34.0462 172.243 34.0462H165.864V33.7858V27.4232H172.309C173.03 27.4232 173.747 27.5892 174.395 27.9213C174.439 27.944 174.468 27.9628 174.49 27.9742C176.292 29.178 176.158 32.5895 174.271 33.6235Z"
          fill="#183E44"
        />
        <path
          d="M147.363 39.6352V39.3635V34.7443V33.065L148.353 34.7443H158.84V31.9555H147.363V27.4232H159.186V24.6344H144.279L144.108 42.2391H159.357V39.6276H147.621L147.363 39.6352Z"
          fill="#183E44"
        />
        <path
          d="M196.02 24.6343C194.105 24.3853 187.999 24.3891 186.084 24.6343C184.157 24.8834 182.395 26.5854 182.162 28.5742C181.925 30.5818 181.893 36.5105 182.158 38.4766C182.424 40.4503 184.263 42.0429 186.171 42.2391C188.378 42.4655 194.116 42.5108 196.264 42.2278C197.553 42.058 198.788 41.1787 199.414 40.0314C199.523 39.8352 199.96 38.9559 199.96 38.8465V35.6199H196.964C196.472 36.1067 196.785 36.9709 196.712 37.6275C196.607 38.537 195.98 39.2993 195.07 39.4427C192.674 39.8201 189.386 39.2163 186.892 39.4163C186.04 39.0389 185.505 38.3936 185.399 37.4464C185.224 35.8727 185.181 30.7668 185.41 29.2648C185.574 28.1779 186.506 27.5138 187.533 27.4156C188.731 27.2986 194.389 27.2496 195.31 27.5402C196.931 28.0534 196.771 29.8686 196.709 31.2611H199.964V28.0345C199.964 26.5137 197.397 24.8117 196.024 24.6343H196.02Z"
          fill="#183E44"
        />
        <path
          d="M209.384 24.6344L201.504 42.2391H205.102L206.664 38.4238L207.625 36.2878L208.317 38.4238H215.96L217.868 42.2391H221.21L213.495 24.6344H209.384ZM208.011 35.6161L211.27 28.1213L214.693 35.6161H208.011Z"
          fill="#183E44"
        />
        <path
          d="M223.603 24.6344L223.432 42.2391H226.687V24.6344H223.603Z"
          fill="#183E44"
        />
      </g>
      <defs>
        <clipPath id="clip0_2464_6126">
          <rect
            width="108.792"
            height="17.9746"
            fill="white"
            transform="translate(117.894 24.4494)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
